<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">     
      
      <el-form :inline="true" class="backborders1 demo-form-inline" size="small" filterable clearable :style="maxheight">			
		  <!--
          <el-form-item style="width:10%">
            	<el-select v-model="query.moneytype" placeholder="额度类型" @change="ischange=true" style="width:100%">
	                <el-option v-for="(item,index) in moneytypelists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select>
          </el-form-item>
          <el-form-item style="width:16%">
            	<template slot-scope="props">
                  <el-input type="text" v-model="query.mstart" style="float:left;width:43%" placeholder="金额下限"></el-input>
                  <div style="float:left;padding:0 2%">~</div>
                  <el-input type="text" v-model="query.mend" style="float:left;width:43%" placeholder="金额上限"></el-input>
              </template>
          </el-form-item>
          -->
          <el-form-item style="width:10%">
            	<el-select v-model="query.status" placeholder="用户状态" clearable @change="ischange=true" style="width:100%">
	                <el-option v-for="(item,index) in statuslists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select>
          </el-form-item>
          <el-form-item style="width:10%">
            	<el-select v-model="query.managerid" filterable clearable placeholder="请选择审核人">
					<el-option v-for="(item,index) in sysmanagers" :key="index" :label="item.truename" :value="item.id"></el-option>
				</el-select>
          </el-form-item>
          <el-form-item style="width:10%">
            	<el-select v-model="query.keytypeid" filterable placeholder="请选择关键字搜索方式">
					<el-option v-for="(item,index) in keytypelists" :key="index" :label="item.name" :value="item.id"></el-option>
				</el-select>
          </el-form-item>
          <el-form-item style="width:18%">
              <el-input placeholder="门店名称 / 客户名称 / 联系方式" v-model="query.key" clearable @change="ischange=true" @keyup.enter.native="getlists" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="getlists">搜索</el-button>
                <el-button size="small" type="danger" icon="el-icon-plus" @click="setcard">账号设置</el-button>
		  </el-form-item>
	  </el-form>

      <div style="margin-top:10px;border-radius:5px;padding:.3rem 1% .3rem 1%;background:rgb(211,211,211,.6)"">
          <span style="font-size:.5rem">已审核<i style="font-style:normal;font-size:.9rem;color:#E6A23C;font-weight:bold"> {{verifys}} </i>家</span>
          <span style="margin-left:2%;font-size:.5rem">未审核<i style="font-style:normal;font-size:.9rem;color:#E6A23C;font-weight:bold"> {{noverifys}} </i>家</span>
          <span style="margin-left:2%;font-size:.5rem">已停用<i style="font-style:normal;font-size:.9rem;color:#E6A23C;font-weight:bold"> {{stops}} </i>家</span>
          <span style="margin-left:2%;font-size:.5rem">授信总额度<i style="font-style:normal;font-size:.9rem;color:#E6A23C;font-weight:bold"> {{totalmoneys}} </i></span>
          <span style="margin-left:2%;font-size:.5rem">用信总额度<i style="font-style:normal;font-size:.9rem;color:#E6A23C;font-weight:bold"> {{getmoneys}} </i></span>
      </div>

      <div class="backborder2" style="margin-top:10px">
          <el-table :data="lists" style="width:100%" v-loading="listloading">
              <el-table-column label="客户信息">
                  <template slot-scope="scope">
                      <span>{{scope.row.username}}</span>
                      <span style="float:left;width:100%;font-size:.7rem;color:#909399">所属店铺：{{scope.row.shopname}}</span>
                      <span style="float:left;width:100%;font-size:.7rem;color:#909399">申请电话：{{scope.row.phone}}</span>
                  </template>
              </el-table-column>
              <el-table-column label="联系地址" prop="address" width="170"></el-table-column>
              <el-table-column label="授信额度" prop="totalmoney" width="120" align="center"></el-table-column>
              <el-table-column label="已使用额度" prop="getmoney" width="120" align="center"></el-table-column>
              <el-table-column label="账号状态" prop="status" width="120" align="center"></el-table-column>
              <el-table-column label="审核人" prop="managername" width="120" align="center"></el-table-column>
              <el-table-column label="申请时间" prop="inputtime" width="170" align="center"></el-table-column>
              <el-table-column label="操作" width="150" align="center">
                  <template slot-scope="scope">
                    <div style="float:left;width:100%;text-align:center">
                      <a href="javascript:;" @click="gethistory(scope.row.id)" style="float:left;margin-right:5%;width:2rem;height:2rem;background:#409EFF;border-radius:50%;"><img src="../../assets/history.png" style="float:left;width:60%;margin:20% 0 0 20%"/></a>
                      <a href="javascript:;" @click="goverify(scope.row.id,'verify')" v-if="scope.row.agent_status==0 || scope.row.agent_status==3 || scope.row.agent_status==4" style="float:left;margin-right:5%;width:2rem;height:2rem;background:#E6A23C;border-radius:50%;"><img src="../../assets/verify.png" style="float:left;width:60%;margin:20% 0 0 20%"/></a>
                      <a href="javascript:;" @click="goverify(scope.row.id,'start')" v-if="scope.row.agent_status==2"  style="float:left;margin-right:5%;width:2rem;height:2rem;background:#67C23A;border-radius:50%;"><img src="../../assets/start.png" style="float:left;width:60%;margin:20% 0 0 20%"/></a>
                      <a href="javascript:;" @click="goverify(scope.row.id,'stop')" v-if="scope.row.agent_status==1"  style="float:left;margin-right:5%;width:2rem;height:2rem;background:#F56C6C;border-radius:50%;"><img src="../../assets/stop.png" style="float:left;width:60%;margin:20% 0 0 20%"/></a>
                      <a href="javascript:;" @click="goverify(scope.row.id,'back')" style="float:left;margin-right:5%;width:2rem;height:2rem;background:#909399;border-radius:50%;"><img src="../../assets/back.png" style="float:left;width:60%;margin:20% 0 0 20%"/></a>
                    </div>
                  </template>
              </el-table-column>
          </el-table>
          <div class="block">
              <el-pagination 
                  @size-change="orderpageSizeChange" 
                  @current-change="orderpageCurrentChange"
                  :current-page="query.p"
                  :page-sizes="[10, 20, 50]"
                  :page-size="query.rollpage"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="rows">
              </el-pagination>
          </div>
	  </div>
      
      <el-dialog :title="reasonname" :visible.sync="verifyDialog"  width="30%" top="15vh">
          <el-input type="textarea" :rows="5" placeholder="请输入原因" v-model="saveverify.reason"></el-input>
          <div slot="footer" class="dialog-footer">
              <el-button size="mini" @click="verifyDialog=false">取消</el-button>
		      <el-button type="primary" size="mini" v-if="saveverify.type=='verify'" @click="saveverifydata(0)">通过审核</el-button>
              <el-button type="primary" size="mini" v-if="saveverify.type=='verify'" @click="saveverifydata(1)">审核失败</el-button>
              <el-button type="primary" size="mini" v-if="saveverify.type!='verify'" @click="saveverifydata(2)">确定</el-button>
		  </div>
      </el-dialog>

      <el-dialog title="审核历史记录" :visible.sync="historyDialog"  width="70%" top="5vh">
          <el-table :data="historylists" style="width:100%" v-loading="historyloading">
              <el-table-column label="审核方" prop="verifyname" ></el-table-column>
              <el-table-column label="审核人" prop="managername" width="120" align="center"></el-table-column>
              <el-table-column label="ip" prop="ip" width="150" align="center"></el-table-column>
              <el-table-column label="审核意见" prop="type" width="120" align="center"></el-table-column>
              <el-table-column label="审核时间" prop="inputtime" width="170" align="center"></el-table-column>
              <el-table-column label="详情" prop="reason" width="150" align="left"></el-table-column>
          </el-table>
      </el-dialog>

      <!-- 代理商新增银行卡号设置 -->
      <el-dialog title="经销商信息设置" :visible.sync="addCardDialog"  width="40%" top="5vh">
          <el-tag type="danger">温馨提示：为了避免分期后无法放款到您手中，请如实、慎重填写以下信息</el-tag>
          
          <el-col :span="24" style="margin-top:10px">
              <el-col :span="24"><div style="float:left;width:100%;padding-bottom:.2rem;border-bottom:1px solid #C0C4CC;font-size:.8rem">经销商信息</div></el-col>
              <el-col :span="10"><el-input placeholder="法人姓名" v-model="Cardquery.custName" :disabled="Cardquery.isapply==0 ? false : true" clearable size="small" style="margin-top:.7rem"></el-input></el-col>
              <el-col :span="2" style="height:.3rem"></el-col>
              <el-col :span="10"><el-input placeholder="手机号" v-model="Cardquery.phone" :disabled="Cardquery.isapply==0 ? false : true" clearable size="small" style="margin-top:.7rem"></el-input></el-col>
              <el-col :span="2" style="height:.3rem"></el-col>
              <el-col :span="10"><el-input placeholder="身份证号" v-model="Cardquery.idCard" :disabled="Cardquery.isapply==0 ? false : true" clearable size="small" style="margin-top:.7rem"></el-input></el-col>
              <el-col :span="2" style="height:.3rem"></el-col>
              <el-col :span="10"><el-input placeholder="企业名称" v-model="Cardquery.workName" :disabled="Cardquery.isapply==0 ? false : true" clearable size="small" style="margin-top:.7rem"></el-input></el-col>
              <el-col :span="2" style="height:.3rem"></el-col>
              <el-col :span="22"><el-input placeholder="企业统一社会信用代码" v-model="Cardquery.workCreditCode" :disabled="Cardquery.isapply==0 ? false : true" clearable size="small" style="margin-top:.7rem"></el-input></el-col>
              <el-col :span="22"><el-input placeholder="经营地址" v-model="Cardquery.workAddress" :disabled="Cardquery.isapply==0 ? false : true" clearable size="small" style="margin-top:.7rem"></el-input></el-col>
              <el-col :span="22"><el-input placeholder="营业执照下载地址" v-model="Cardquery.workImage" :disabled="Cardquery.isapply==0 ? false : true" clearable size="small" style="margin-top:.7rem"></el-input></el-col>
              <el-col :span="24"><div style="float:left;width:100%;margin-top:30px;padding-bottom:.2rem;border-bottom:1px solid #C0C4CC;font-size:.8rem">绑定银行卡信息</div></el-col>
              <el-col :span="10"><el-input placeholder="开户行名称" v-model="Cardquery.bankName" :disabled="Cardquery.isapply==0 ? false : true" clearable size="small" style="margin-top:.7rem"></el-input></el-col>
              <el-col :span="2" style="height:.3rem"></el-col>
              <el-col :span="10"><el-input placeholder="银行账号" v-model="Cardquery.bankcardNo" :disabled="Cardquery.isapply==0 ? false : true" clearable size="small" style="margin-top:.7rem"></el-input></el-col>
              <el-col :span="2" style="height:.3rem"></el-col>
              <el-col :span="10">
                  <el-select v-model="Cardquery.bankcardType" placeholder="银行卡类型" size="small" style="margin-top:.7rem" clearable :disabled="Cardquery.isapply==0 ? false : true">
	                  <el-option v-for="(item,index) in cartypelists" :label="item.name" :value="item.id" :key="index"></el-option>
	              </el-select>  
              </el-input></el-col>
              <el-col :span="2" style="height:.3rem"></el-col>
          </el-col>

          <div slot="footer" class="dialog-footer">
              <el-button size="mini" @click="addCardDialog=false">取消</el-button>
		      <el-button type="primary" size="mini"  @click="savecard">确定</el-button>
		  </div>
      </el-dialog>
      
          
  </div>
  </transition> 
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Xy/index",
      transitionshow:true,
      query: {
        act:'getuserlists',
        token: this.$cookies.get('token'),
        moneytype:1,
        mstart:'',
        mend:'',
        status:'',
        managerid:'',
        keytypeid:1,
        key:'',
        p:1,
        rollpage:10
      },
      managerlists:[],
      lists:[],
      rows:0,
      listloading:false,
      ischange:false,
      moneytypelists:[
        {id:1,name:'授信额度'},
        {id:2,name:'已使用额度'}
      ],
      statuslists:[
        {id:1,name:'未审核'},
        {id:2,name:'审核通过'},
        {id:3,name:'停用'},
        {id:4,name:'审核失败'}
      ],
      keytypelists:[
        {id:1,name:'门店名称'},
        {id:2,name:'客户名称'},
        {id:3,name:'联系方式'}
      ],
      verifys:0,
      noverifys:0,
      stops:0,
      totalmoneys:0,
      getmoneys:0,
      saveverify: {
          act:'saveverify',
          token:this.$cookies.get('token'),
          id:'',
          type:'',
          reason:'',
          result:'',
      },
      verifyDialog:false,
      reasonname:'',
      verifyhistory: {
          act:'verifyhistory',
          token:this.$cookies.get('token'),
          id:'',
          p:1,
          rollpage:10,
      },
      historylists:[],
      historyDialog:false,
      historyloading:false,
      addCardDialog:false,
      Cardquery: {
          act:'addcardquery',
          token:this.$cookies.get('token'),
          custName:'',
          idCard:'',
          workName:'',
          workCreditCode:'',
          bankName:'',
          bankcardNo:'',
          bankcardType:'',
          phone:'',
          workAddress:'',
	      workImage:'',
          isapply:'',  
      },
      cartypelists:[
          {id:1,name:'个人储蓄卡（DC）'},
          {id:2,name:'公司对公账户（CA）'}
      ],

    }  
  },
  mounted(){
      this.getSysmanager(); //获取管理员信息
      this.getlists(); //获取审核信息
  },
  methods:{

      /** 银行卡账号设置 **/
      setcard() {
          this.addCardDialog=true;
          this.Cardquery.custName='';
          this.Cardquery.idCard='';
          this.Cardquery.workCreditCode='';
          this.Cardquery.bankName='';
          this.Cardquery.bankcardNo='';
          this.Cardquery.bankcardType='';
          this.Cardquery.phone='';
          this.Cardquery.isapply='';

          var resource = this.$resource(this.url);
	      resource.query({act:'getcardinfos',token:this.$cookies.get('token')}).then((res) => {
		      if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
		      }else{
		          var result = JSON.parse(Base64.decode(res.data.Data));
                  this.Cardquery.custName=result.custName;
                  this.Cardquery.idCard=result.idCard;
                  this.Cardquery.workName=result.workName;
                  this.Cardquery.workCreditCode=result.workCreditCode;
                  this.Cardquery.bankName=result.bankName;
                  this.Cardquery.bankcardNo=result.bankcardNo;
                  this.Cardquery.bankcardType=Number(result.bankcardType);
                  this.Cardquery.phone=result.phone;
                  this.Cardquery.workAddress=result.workAddress;
                  this.Cardquery.workImage=result.workImage;
                  this.Cardquery.isapply=result.isapply; 
		      }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },

      /** 保存银行卡信息 **/
      savecard() {
          var resource = this.$resource(this.url);
	      resource.query(this.Cardquery).then((res) => {
		      if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
		      }else{
		          this.$message.success("设置银行卡号信息成功");
                  this.addCardDialog=false;        
		      }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },

      /** 获取小也审核用户信息 **/
      getlists() {
          if(this.ischange==true) {
              this.query.p=1;
              this.query.rollpage=10;
          }
          
          this.listloading=true;
          var resource = this.$resource(this.url);
	        resource.query(this.query).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
                this.listloading=false;
		        }else{
		            var result = JSON.parse(Base64.decode(res.data.Data));
                    this.lists= result.lists;
                    this.rows = result.count;
                    this.verifys=result.verify;
                    this.noverifys=result.noverify;
                    this.stops=result.stop;
                    this.totalmoneys=result.totalmoney;
                    this.getmoneys=result.getmoney;

                    this.listloading=false;
                    if(this.ischange==true) this.ischange=false;           
		        }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
              this.listloading=false;
	        });
      },

      /** 下一页 **/
  	    orderpageSizeChange(val) {
  	        this.query.rollpage = val;
            this.getlists();
  	    },
  	    /** 下一页 **/
  	    orderpageCurrentChange(val) {
  	        this.query.p = val;
            this.getlists();
  	    },

      /** 获取经手人 **/
	  getSysmanager() {
	        var resource = this.$resource(this.GLOBAL.domain+"Manager/index");
	        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000,p:1}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.sysmanagers = JSON.parse(Base64.decode(res.data.Data));           
		        }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	        });
	  },
      
      /** 审核操作 **/
      goverify(id,type) {
          this.saveverify.id=id;
          this.saveverify.type=type;
          this.saveverify.reason='';

          if(type=='verify') this.reasonname="审核用户";
          if(type=='start') this.reasonname="启用";
          if(type=='stop') this.reasonname="停止使用";
          if(type=='back') this.reasonname="退回平台方审核";
          this.verifyDialog=true;
      },

      /** 保存审核结果信息 **/
      saveverifydata(result) {
          this.saveverify.result=result;
          var resource = this.$resource(this.url);
	      resource.save(this.saveverify).then((res) => {
		      if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
		      }else{
                  this.verifyDialog=false;
		          this.getlists();    
		      }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },

      /** 获取小也用户审核记录 **/
      gethistory(id) {
          this.historyDialog=true;
          this.historyloading=true;
          this.verifyhistory.id=id;
          var resource = this.$resource(this.url);
	      resource.query(this.verifyhistory).then((res) => {
		      if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
                  this.historyloading=false;
		      }else{
                  this.historylists=[];
		          this.historylists = JSON.parse(Base64.decode(res.data.Data));  
                  this.historyloading=false;         
		      }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
              this.historyloading=false;
	      });
      },

  }
}
</script>
<style>
.backborders1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 1% 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/mall/Paysettingxiaoye.vue